export const SetupWSEventListener = (fetchData) => {
    const bc = new BroadcastChannel('ws-events');
    let debounceTimer = null;
    const handler = ({ data }) => {
        if (/_created|_updated|_deleted|_patched|_failed/.test(data.event)) { // Filtra eventi rilevanti
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                fetchData();
            }, 220);
        }
    };
    bc.addEventListener('message', handler);
    return () => {
        clearTimeout(debounceTimer);
        bc.removeEventListener("message", handler); // cleanup evento
        bc.close();
    };
}

//listener specifico per evento  di stampa fallita
export const PrintEventListener = (socketFunction) => { 
    const bc = new BroadcastChannel('ws-events');
    const handler = ({ data }) => {
        if (data.event === 'print_failed') {
            socketFunction(data.data);
        }
    };
    bc.addEventListener('message', handler);
    return () => {
        bc.removeEventListener("message", handler); // cleanup evento
        bc.close();
    };
}
